import { NgModule } from '@angular/core';
import { RouterModule } from "@angular/router";
import { routes } from './help-desk.common';

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [ RouterModule]
})
export class HelpDeskRoutingModule {
}